module.exports = __webpack_public_path__ + "img/texto-uno.fe5976b0.png";